import { setIn } from 'immutable';
import uuid from 'uuid/v1';
import { DEFAULT_GOAL, default_one_check_upsell } from 'lib/globals';

export const SET_ITEM = 'SET_ITEM';
export const NEW_GOAL = 'NEW_GOAL';
export const NEW_SPECIFIC_GOAL = 'NEW_SPECIFIC_GOAL';
export const REMOVE_SPECIFIC_GOAL = 'REMOVE_SPECIFIC_GOAL';
export const DELETE_GOAL = 'DELETE_GOAL';
export const NEW_OCU_PRODUCT = 'NEW_OCU_PRODUCT';
export const DELETE_OCU_PRODUCT = 'DELETE_OCU_PRODUCT';
export const NEW_BUNDLE = 'NEW_BUNDLE';
export const DELETE_BUNDLE = 'DELETE_BUNDLE';
export const DISCARD = 'DISCARD';
export const UPDATE_OLD_OCU = 'UPDATE_OLD_OCU';
export const CampaignReducer = (default_language = 'english', default_currency = 'USD') => {
    return (state, { type, path, value, goal_index }) => {
        switch (type) {
            case DISCARD:
                return { ...value };
            case SET_ITEM:
                return setIn(state, path.split('.'), value);
            case NEW_BUNDLE:
                return setIn(
                    state,
                    ['settings', 'bundles', 'list'],
                    state.settings.bundles.list.concat([
                        {
                            id: uuid(),
                            type: 'percentage',
                            reward: '',
                            quantity: ''
                        }
                    ])
                );
            case DELETE_BUNDLE:
                return setIn(
                    state,
                    ['settings', 'bundles', 'list'],
                    state.settings.bundles.list.filter(({ id }) => id !== value)
                );
            case NEW_GOAL:
                return setIn(
                    state,
                    ['settings', 'add_to_unlock', 'goals'],
                    state.settings.add_to_unlock.goals.concat(
                        DEFAULT_GOAL(
                            state.settings.add_to_unlock,
                            default_language,
                            default_currency
                        )
                    )
                );
            case NEW_SPECIFIC_GOAL:
                return setIn(
                    state,
                    ['settings', 'add_to_unlock', 'goals', value, 'specific_goals'],
                    state.settings.add_to_unlock.goals[value].specific_goals.concat({
                        currency: '',
                        goal: ''
                    })
                );
            case REMOVE_SPECIFIC_GOAL:
                return setIn(
                    state,
                    ['settings', 'add_to_unlock', 'goals', goal_index, 'specific_goals'],
                    state.settings.add_to_unlock.goals[goal_index].specific_goals.filter(
                        (_, index) => index !== value
                    )
                );
            case DELETE_GOAL:
                let newGoals = state.settings.add_to_unlock.goals.slice(0);
                newGoals.splice(value, 1);
                return setIn(state, ['settings', 'add_to_unlock', 'goals'], newGoals);
            case NEW_OCU_PRODUCT:
                return setIn(
                    state,
                    ['settings', 'multi_one_check_upsell', 'products'],
                    state.settings.multi_one_check_upsell.products.concat([
                        default_one_check_upsell(default_language)
                    ])
                );
            case DELETE_OCU_PRODUCT:
                let newProducts = state.settings.multi_one_check_upsell.products.slice(0);
                newProducts.splice(value, 1);
                return setIn(
                    state,
                    ['settings', 'multi_one_check_upsell', 'products'],
                    newProducts
                );
            case UPDATE_OLD_OCU:
                const new_state = setIn(state, ['settings', 'multi_one_check_upsell'], value);
                return setIn(new_state, ['settings', 'one_check_up_sell'], undefined);
            default:
                return state;
        }
    };
};
